import { useEffect, useState } from "react";
import { peopleApi, type Person, type PersonKind } from "../lib/api";
import { Combobox } from "../ui/Combobox";

// 269_a: the employee or student a line is for, on an account kept person by person (Advances to Employees, Fees
// Receivable from Students …). Each is shown with their unique ID, so two people with the same name can't be mixed up.
const cache = new Map<string, Promise<Person[]>>();
export function usePeople(company: string, kind: PersonKind | null | undefined): Person[] | null {
  const [r, setR] = useState<Person[] | null>(null);
  useEffect(() => {
    if (!kind) return;
    let live = true;
    const k = `${company}:${kind}`;
    if (!cache.has(k)) cache.set(k, peopleApi.list(company, kind).catch(() => { cache.delete(k); return []; }));
    void cache.get(k)!.then((x) => { if (live) setR(x); });
    return () => { live = false; };
  }, [company, kind]);
  return r;
}
export const forgetPeople = (company: string) => { for (const k of [...cache.keys()]) if (k.startsWith(company + ":")) cache.delete(k); };

export function PersonPick({ company, kind, value, onChange, missing }: {
  company: string; kind: PersonKind | null | undefined; value: string | null | undefined; onChange: (id: string | null) => void; missing?: boolean;
}) {
  const people = usePeople(company, kind);
  if (!kind) return null;
  const options = (people ?? []).filter((p) => p.active || p.id === value)
    .map((p) => ({ value: p.id, label: `${p.name} · ${p.code}`, hint: kind === "student" ? [p.enrolment?.year_class, p.enrolment?.course, p.enrolment?.section].filter(Boolean).join(" ") : p.details.designation }));
  return (
    <div className={`person-pick${missing ? " invalid" : ""}`}>
      <Combobox options={options} value={value ?? null} onChange={onChange}
        placeholder={people && !people.length ? `No ${kind}s yet: add them under Accounting` : kind === "student" ? "Which student?" : "Which employee?"} />
    </div>
  );
}
